/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_File_TypeInputs */

const es_settings_files_filters_file_type = /** @type {(inputs: Settings_Files_Filters_File_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de archivo`)
};

const en_settings_files_filters_file_type = /** @type {(inputs: Settings_Files_Filters_File_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File type`)
};

/**
* | output |
* | --- |
* | "File type" |
*
* @param {Settings_Files_Filters_File_TypeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_file_type = /** @type {((inputs?: Settings_Files_Filters_File_TypeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_File_TypeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_file_type(inputs)
	return en_settings_files_filters_file_type(inputs)
});
export { settings_files_filters_file_type as "settings.files.filters.file_type" }